import { useProductData } from 'components/common-form/hooks/useData';
import { InfoIconButton } from 'components/shared/InfoIconButton';
import { InfoTooltip } from 'components/shared/InfoTooltip';
import { useHelpCenterFeature } from 'hooks/use-help-center-feature';
import { useIsAnyRouteActive } from 'hooks/use-is-any-route-active';
import type { IntlKey } from 'locales';
import type { GimmickName } from 'models/forms/fields';
import { useIntl } from 'react-intl';

interface LabelGimmickItemProp {
  gimmick: GimmickName;
  labelKey: IntlKey;
}

export function LabelGimmickItem({ gimmick, labelKey }: LabelGimmickItemProp) {
  const isStaticScreen = useIsAnyRouteActive('/static');

  if (isStaticScreen) {
    return <StaticLabelGimmickItem gimmick={gimmick} labelKey={labelKey} />;
  }

  return <BaseLabelGimmickItem gimmick={gimmick} labelKey={labelKey} />;
}

function StaticLabelGimmickItem({ gimmick, labelKey }: LabelGimmickItemProp) {
  const { productSubtype, productType } = useProductData();
  const { exists, open } = useHelpCenterFeature({ name: gimmick, productType, productSubtype });

  const { formatMessage } = useIntl();
  const label = formatMessage({ id: labelKey });

  return (
    <>
      <label className="text-primary" data-help-center-name={gimmick}>
        {label}
      </label>
      {exists && <InfoIconButton className="ms-1" onClick={open} />}
    </>
  );
}

function BaseLabelGimmickItem({ gimmick, labelKey }: LabelGimmickItemProp) {
  const { formatMessage } = useIntl();
  const label = formatMessage({ id: labelKey });

  return (
    <>
      <label className="text-primary">{label}</label>
      <InfoTooltip
        id={`info-feature-toggle-${gimmick}`}
        tooltipKey={`feature.${gimmick}.tooltip` satisfies IntlKey}
        tooltipPlacement="bottom"
      />
    </>
  );
}
